import cx from 'classnames';
import { CtaBookNow } from 'themes/playful/components/CtaBookNow/CtaBookNow';
import { Title } from 'themes/playful/components/Title/Title';

import Spinner from 'components/Spinner';

import { usePortfolioPage } from 'hooks/page/portfolio/usePortfolioPage';

import { PlayfulPortfolioImage } from './components/PlayfulPortfolioImage';

import s from './PlayfulPortfolio.module.css';
import s1 from 'themes/playful/components/PlayfulLayout.module.css';

export const PlayfulPortfolio = () => {
  const { isLoading, images } = usePortfolioPage();

  return (
    <>
      <div className={cx(s1.content, s.root)}>
        <Title className={s.title}>Portfolio</Title>
        <div className={s.container}>
          {images &&
            images.map((image) => (
              <PlayfulPortfolioImage
                key={image.image.medium}
                image={image.image}
                caption={image.caption}
              />
            ))}
          <Spinner loading={isLoading} />
        </div>
      </div>
      <CtaBookNow />
    </>
  );
};
